<field-select label="" {(field)}="interval" {options}="intervalOptions"></field-select>
{{#if hasProgDuration}}
  <field-text label-key="field.duration" {(field)}="duration" format="pint" min="1" max="59"></field-text>
{{/if}}
